import React, { Component } from 'react';
import axios from 'axios'
import {BASE_URL} from "../../config";

class Rating extends Component {

  state = {
    winners: []
  }

  componentWillMount () {

    const { token } = this.props
    let authToken = {'Authorization': 'Bearer ' + token}

    axios({
      url: BASE_URL +'/rating/3/',
      method: 'get',
      headers: authToken,
    }).then((res) => {
      console.log(res.data)
      this.setState({winners: res.data})
    })
  }

  renderTableRows = () => {
    const { winners } = this.state
    return winners.map((winner, index) => {
      if (index < 10) {
        return (
          <tr className={index < 3 ? 'row--winner' : null} key={winner.user}>
            <td>
            <span>
              {index < 3 ? <img src="/images/cup.png" alt="" className="rating__cup"/> : null}
              {index+1}. {winner.user}
            </span>
            </td>
            <td>
            <span>
              <img src="/images/ok.svg" alt="" className="rating__ok"/>
              {winner.score}/17
            </span>
            </td>
            <td>
            <span>
              <img src="/images/stopwatch.png" alt="" className="rating__watch"/>
              {winner.time}
            </span>
            </td>
          </tr>
        )
      } else {
        return true
      }
    })
  }

  render () {
    return (
      <div className="test__rating">
        <h1 className="h1 h1--finish">личный зачет</h1>

        <div className="rating__text">Перед вами таблица 10 лучших гонщиков. Три гонщика, занявших высшие места получат сертификат на тест-драйв от Porsche. Конкурс завершен, но тест пройти все равно стоит!</div>

        <table className="rating__table">
          <tbody>
            {this.renderTableRows()}
          </tbody>
        </table>
      </div>
    )
  }
}

export default Rating


// WEBPACK FOOTER //
// ./src/pages/test/rating.js